import React from 'react';

// Wordmark MTSRpay: MTSR biru royal + pay hijau emerald, adaptif dark mode
export function Wordmark({ className = '', size = 'text-2xl' }) {
  return (
    <span className={`font-extrabold tracking-tight ${size} ${className}`} data-testid="brand-wordmark">
      <span className="text-brand dark:text-blue-400">MTSR</span>
      <span className="text-emerald-600 dark:text-emerald-400">pay</span>
    </span>
  );
}

export function LogoMark({ className = '', size = 40 }) {
  return (
    <img
      src="/mtsrpay-logo.webp"
      alt="MTSRpay"
      width={size}
      height={size}
      className={`object-contain ${className}`}
      style={{ height: size, width: 'auto' }}
      data-testid="brand-logo"
    />
  );
}

export function LogoFull({ className = '', imgSize = 40, textSize = 'text-2xl' }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <LogoMark size={imgSize} />
      <Wordmark size={textSize} />
    </div>
  );
}
